import React, {useEffect, useState} from 'react';
import {useMutation, useQuery, useQueryClient} from "react-query";
import {findGateById} from "./HistoryFunctions";
import {Loader} from "@mantine/core";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {summaryBoxActions} from "../../store/slice/summarySlice";
import {creatorActions} from "../../store/slice/gateCreatorSlice";
import copyIcon from "../../assets/icons/copy.png";
import downloadIcon from "../../assets/icons/download.png";
import {authorizedPatchWithId, authorizedPost, authorizedPutWithId} from "../Creator/CreatorFunctions";
import {useDispatch, useSelector} from "react-redux";
import arrowUpIcon from "../../assets/icons/expanded.png";
import useTranslations from "../../hooks/useTranslations";
import okIcon from "../../assets/icons/ok.png";

const CustomGateDetails = ({gate, item, index,setIndustrialGate,setIsSearchingIndustrial}) => {
        const accessToken = localStorage.getItem("token");
        const history = useHistory();
        const params = useParams();
        const location = useLocation()
        const queryClient = useQueryClient();
        const dispatch = useDispatch();
        const user = useSelector(state => state.user);
        const [clickedItem, setClickedItem] = useState(null);
        const {
            data: gateDetailed,
            isLoading,
            isFetching
        } = useQuery(["gateDetails", gate.id], () => findGateById(accessToken, gate.gate), {
            keepPreviousData: false,
            refetchOnWindowFocus: false,
            onSuccess: data => {
                if ((data.gateType?.name.toLowerCase().includes('przemysłowa') && data?.leading?.priceType === 3)) {
                    setIndustrialGate(prev => {
                        const exists = prev.some(g => g.id === data.id);

                        if (!exists && data.gateType?.name.toLowerCase().includes('przemysłowa') && data?.leading?.priceType === 3) {
                            return [data, ...prev];
                        }

                        return prev;
                    });
                }
                setIsSearchingIndustrial(false)
            }
        })

        const addGateAccessoriesToCartMutation = useMutation(authorizedPatchWithId);
        const updateGateMutation = useMutation(authorizedPutWithId)
        const createGateMutation = useMutation(authorizedPost, {
            onSuccess: (e) => {
                setTimeout(() => {
                    createGateMutation.reset()
                }, 2000)
            },
            onError: (e) => {
                setTimeout(() => {
                    createGateMutation.reset()
                }, 2000)
            }
        })
    const duplicateGateMutation = useMutation(authorizedPost, {
        onSuccess: (e) => {
            setTimeout(() => {
                createGateMutation.reset()
            }, 2000)
        },
        onError: (e) => {
            setTimeout(() => {
                createGateMutation.reset()
            }, 2000)
        }
    })
        const getPDF = async (url, lang = 'pl') => {

            try {
                let httpClient = new XMLHttpRequest();
                let pdfLink = `${process.env.REACT_APP_API_URL}/api/orders/${item.id}/${url}?lang=${lang}`;
                httpClient.open('get', pdfLink, true);
                httpClient.setRequestHeader("Authorization", `Bearer ${accessToken}`)
                httpClient.responseType = "blob";
                httpClient.onload = function () {
                    const file = new Blob([httpClient.response], {type: 'application/pdf'});
                    const fileURL = URL.createObjectURL(file);
                    const link = document.createElement("a");
                    link.href = fileURL;
                    link.download = `${params.type === "offers" ? item.offerNumber : item.orderNumber}.pdf`;
                    link.click();
                    // document.body.removeChild(link);
                    URL.revokeObjectURL(fileURL);
                };
                httpClient.send();
            } catch (e) {
                console.log(e);
            }
        }
        const {
            alignTop,
            alignCenter,
            alignLeft,
            alignRight,
            position,
            align,
            lack,
            historyKTMDescription,
            historyQty,
            cartItemsGateType,
            cartItemsWidth,
            cartItemsHeight,
            cartItemsLeading,
            cartItemsLintel,
            cartItemsAreaLeft,
            cartItemsAreaRight,
            cartItemsDepth,
            cartItemsDrive,
            cartItemsGateAccessories,
            downloadPdfButton,
            copyButton,
            downloadClientPdfButton,
            historyOrderFromOffer,
            historyOrderFromOfferError,
            historyDuplicateButton,
            expandText,
            collapseText,
            editButton,
            language
        } = useTranslations();

        return (
            <div style={{marginBottom: 20}}>
                {isLoading &&
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 30,
                        width: "100%"
                    }}><Loader/></div>}
                <div className="basket-left">
                    <div className="basket-box">
                        <div className="basket-item">
                            <p className="basket-item__left basket-item__left--round">{index + 1}</p>
                            <p className="basket-item__right">
                                <div
                                    className="accordion-icons flex">
                                    {clickedItem !== item.id ? expandText : collapseText}
                                    <img
                                        className={`accordion-icons__expand ${clickedItem !== item.id ? "show" : ""}`}
                                        onClick={(e) => {
                                            setClickedItem(prev => {
                                                if (prev === item.id) {
                                                    return null
                                                } else {
                                                    return item.id
                                                }
                                            })
                                        }} src={arrowUpIcon}
                                        alt="accordion icon"/>
                                </div>
                            </p>
                        </div>
                    </div>
                    <div className="basket-box">
                        <div className="basket-item">
                            <p className="basket-item__left">KTM</p>
                            <p className="basket-item__right">{gateDetailed?.ktmCode}</p>
                        </div>
                    </div>
                    <div className="basket-box">
                        <div className="basket-item">
                            <p className="basket-item__left" style={{whiteSpace: 'nowrap'}}>{historyKTMDescription}</p>
                            <p className="basket-item__right">{gateDetailed?.ktmCodeDescription}</p>
                        </div>
                    </div>
                    <div className="basket-box">
                        <div className="basket-item">
                            <p className="basket-item__left" style={{whiteSpace: 'nowrap'}}>{historyQty}</p>
                            <p className="basket-item__right">{gate?.quantity || '-'}</p>
                        </div>
                    </div>
                    {clickedItem === item.id && <>
                        <div className="basket-box">
                            <div className="basket-item">
                                <p className="basket-item__left">{cartItemsGateType}</p>
                                <p className="basket-item__right">{gateDetailed?.gateType?.name}</p>
                            </div>
                        </div>
                        <div className="basket-box">
                            {!!gateDetailed?.width?.value && <div className="basket-item">
                                <p className="basket-item__left">{cartItemsWidth}</p>
                                <p className="basket-item__right">{gateDetailed?.width?.value} mm</p>
                            </div>}
                            {!!gateDetailed?.height?.value && <div className="basket-item">
                                <p className="basket-item__left">{cartItemsHeight}</p>
                                <p className="basket-item__right">{gateDetailed?.height?.value} mm</p>
                            </div>}
                            {!!gateDetailed?.depth && <div className="basket-item">
                                <p className="basket-item__left">{cartItemsDepth}</p>
                                <p className="basket-item__right">{gateDetailed?.depth} mm</p>
                            </div>}
                            {!!gateDetailed?.rightArea && <div className="basket-item">
                                <p className="basket-item__left">{cartItemsAreaRight}</p>
                                <p className="basket-item__right">{gateDetailed?.rightArea} mm</p>
                            </div>}
                            {!!gateDetailed?.leftArea && <div className="basket-item">
                                <p className="basket-item__left">{cartItemsAreaLeft}</p>
                                <p className="basket-item__right">{gateDetailed?.leftArea} mm</p>
                            </div>}
                            {!!gateDetailed?.lintel?.value && <div className="basket-item">
                                <p className="basket-item__left">{cartItemsLintel}</p>
                                <p className="basket-item__right">{gateDetailed?.lintel?.value} mm</p>
                            </div>}
                            {!!gateDetailed?.drive && <div className="basket-item">
                                <p className="basket-item__left">{cartItemsDrive}</p>
                                <p className="basket-item__right">{gateDetailed?.drive?.name}</p>
                            </div>}
                            {!!gateDetailed?.leading?.name && <div className="basket-item">
                                <p className="basket-item__left">{cartItemsLeading}</p>
                                <p className="basket-item__right">{gateDetailed?.leading?.name}</p>
                            </div>}
                            {gateDetailed?.componentItems?.length > 0 && gateDetailed?.componentItems.map(comp => {
                                return (
                                    <div className="basket-item">
                                        <p className="basket-item__left">{comp?.component?.name}</p>
                                        <p className="basket-item__right">{comp?.name}</p>
                                    </div>
                                )
                            })}
                        </div>

                        <div className="basket-box">
                            <div className="basket-item">
                                <p className="basket-item__left">{cartItemsGateAccessories}</p>
                            </div>
                            {gateDetailed?.gateAccessories?.map(i => {
                                return (
                                    <div className="basket-item">
                                        <p className="basket-item__left">{i?.gateAccessory?.category?.name}</p>
                                        {i.position ? <p className="basket-item__right">
                                        {position + " " + i.position + ` , ${align} `}
                                        {i.alignment === 1 &&
                                            <span>{alignRight}</span> || i.alignment === 2 &&
                                            <span>{alignLeft}</span> || i.alignment === 3 &&
                                            <span>{alignCenter}</span> || i.alignment === 4 &&
                                            <span>{alignTop}</span>}
                                    </p> :
                                        <p className="basket-item__right">{i?.gateAccessory?.name} {i?.gateAccessory?.name.toLocaleLowerCase() !== lack ? `(x${i.quantity})` : ''}</p>}
                                    </div>
                                )
                            })}
                        </div>
                    </>}
                </div>

                {!isLoading && clickedItem === item.id && <div className="basket-right">
                    <div className="buttons-box"
                         style={params.type === "offers" || location.pathname === '/orders_clients' ? {maxWidth: "unset"} : null}>
                        {location.pathname === '/orders_clients' && <button
                            onClick={() => getPDF('get_pdf')}
                            className="main-button">{downloadPdfButton}<img
                            src={downloadIcon} alt="background image"/></button>}
                        {location.pathname === '/orders_clients' && <button
                            onClick={() => getPDF('client_get_pdf', language)}
                            className="main-button">{downloadClientPdfButton}<img
                            src={downloadIcon} alt="background image"/></button>}
                        <button
                            onClick={() => {
                                dispatch(summaryBoxActions.updateCurrentStep(1))
                                createGateMutation.mutate({
                                        url: "/api/gates",
                                        data: {
                                            gateType: gateDetailed?.gateType?.id,
                                            client: user.userId
                                        }
                                    }, {
                                        onSuccess: (data) => {
                                            updateGateMutation.mutate({
                                                url: "/api/gates",
                                                id: data.id,
                                                data: {
                                                    ...item.gate,
                                                    id: data.id,
                                                    gateType: gateDetailed?.gateType?.id,
                                                    width: gateDetailed?.width?.id,
                                                    height: gateDetailed?.height?.id,
                                                    depth: gateDetailed?.depth,
                                                    rightArea: gateDetailed?.rightArea,
                                                    leftArea: gateDetailed?.leftArea,
                                                    lintel: gateDetailed?.lintel?.id,
                                                    drive: gateDetailed?.drive?.id,
                                                    leading: gateDetailed?.leading?.id,
                                                    componentItems: gateDetailed?.componentItems.map(e => e.id),
                                                }
                                            })
                                            gateDetailed.gateAccessories.forEach(e => {
                                                addGateAccessoriesToCartMutation.mutate({
                                                    url: `/api/gates/${data.id}/add_gate_accessory`,
                                                    data: {
                                                        gate_accessory: e.gateAccessory.id
                                                    }
                                                })
                                            })

                                            dispatch(creatorActions.updateCreator({
                                                id: data.id,
                                                isOffer: params.type === "offers",
                                                isOrder: params.type === "offers"
                                            }))
                                            history.push('/creator/step/1')
                                            if (item?.drives?.length > 0) {
                                                dispatch(summaryBoxActions.updateNumberOfSteps(5))
                                            } else {
                                                dispatch(summaryBoxActions.updateNumberOfSteps(4))
                                            }
                                        }
                                    }
                                )

                                dispatch(creatorActions.updateCreator({
                                    chosenGate: gateDetailed.gateType,
                                    ...gateDetailed
                                }))
                            }
                            }
                            className="main-button">{copyButton}<img
                            src={copyIcon} alt="background image"/>
                        </button>
                        {params.type === "offers" && <button
                            onClick={() => {
                                dispatch(summaryBoxActions.updateCurrentStep(1))
                                dispatch(creatorActions.updateCreator({
                                    ...item,
                                    id: item.id,
                                    isOffer: true,
                                    isOrder: false,
                                    isEdit: true,
                                    offerId: item?.id,
                                    ...gateDetailed
                                }))
                                history.push('/creator/step/1')
                            }
                            }
                            className="main-button">{editButton}<img
                            src={copyIcon} alt="background image"/>
                        </button>}

                        {createGateMutation.isSuccess &&
                            <p style={{textAlign: "center", color: "green"}}>{historyOrderFromOffer}</p>}
                        {createGateMutation.isError &&
                            <p style={{textAlign: "center", color: "red"}}>{historyOrderFromOfferError}</p>}
                    </div>
                </div>}
            </div>

        )
            ;
    }
;

export default CustomGateDetails;
